import announcementTypes from 'dashboard/actions/announcements/announcement-types';
import template from './scheduled-announcements.html';

const mapStateToThis = ({ announcements }) => {
  const { isLoading, scheduled } = announcements;

  return {
    isLoading,
    scheduled,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class ScheduledAnnouncementsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.type = announcementTypes.SCHEDULED;
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class ScheduledAnnouncementsComponent {
  constructor() {
    this.template = template;
    this.controller = ScheduledAnnouncementsController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/scheduled-announcements/scheduled-announcements-component.js